// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   KIU Resource Management System - Login Page Styles
   ========================================================================== */

.kiu-login-wrapper {
  position: relative;
  min-height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #ffffff;
  transition: all 0.5s ease;
}

/* Background Video & Overlays */
.kiu-video-bg-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  background-color: #0b0f19;
}

.kiu-video-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.8s;
  pointer-events: none;
}

.kiu-video-bg.active {
  opacity: 1;
  visibility: visible;
}

.kiu-video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  transition: background 0.6s ease;
}

/* Night Mode Overlay */
.kiu-login-wrapper.night-mode .kiu-video-overlay {
  background: radial-gradient(circle at 75% 50%, rgba(15, 23, 42, 0.25) 0%, rgba(10, 14, 26, 0.72) 100%),
              linear-gradient(to right, rgba(10, 15, 30, 0.88) 0%, rgba(10, 15, 30, 0.45) 50%, rgba(10, 15, 30, 0.75) 100%);
}

/* Day Mode Overlay */
.kiu-login-wrapper.day-mode .kiu-video-overlay {
  background: radial-gradient(circle at 75% 50%, rgba(15, 23, 42, 0.08) 0%, rgba(15, 23, 42, 0.45) 100%),
              linear-gradient(to right, rgba(15, 23, 42, 0.75) 0%, rgba(15, 23, 42, 0.22) 50%, rgba(15, 23, 42, 0.55) 100%);
}

/* Header */
.kiu-login-header {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 48px 0;
  flex-shrink: 0;
}

.kiu-brand-container {
  display: flex;
  align-items: center;
  gap: 14px;
  text-decoration: none;
}

.kiu-crest-logo {
  height: 58px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.3));
}

.kiu-brand-text {
  display: flex;
  flex-direction: column;
}

.kiu-brand-title {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  color: #e51937;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, serif;
}

.kiu-brand-subtitle {
  font-size: 10.5px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-top: 3px;
  opacity: 0.95;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}

.kiu-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.kiu-theme-toggle {
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #ffffff;
  border-radius: 9999px;
  padding: 7px 16px;
  font-size: 12.5px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.kiu-theme-toggle:hover {
  background: rgba(255, 255, 255, 0.26);
  border-color: rgba(255, 255, 255, 0.45);
  transform: translateY(-1px);
}

.kiu-secure-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  padding: 7px 16px;
  border-radius: 9999px;
  font-size: 12.5px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.kiu-secure-badge i {
  color: #60a5fa;
  font-size: 15px;
}

.kiu-version-divider {
  opacity: 0.4;
  margin: 0 3px;
}

/* Main Content Area */
.kiu-login-main {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 56px;
  width: 100%;
  max-width: 1560px;
  margin: auto;
  flex: 1 1;
}

/* Hero Content (Left) */
.kiu-hero-left {
  max-width: 560px;
  padding-right: 36px;
}

.kiu-hero-overline {
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #a5b4fc;
  margin-bottom: 8px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.kiu-hero-title {
  font-size: 40px;
  font-weight: 800;
  line-height: 1.15;
  color: #ffffff;
  margin: 0 0 10px;
  letter-spacing: -0.5px;
  text-shadow: 0 3px 12px rgba(0, 0, 0, 0.45);
}

.kiu-hero-title .kiu-accent {
  color: #9333ea;
  background: linear-gradient(135deg, #a855f7 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  margin-right: 8px;
}

.kiu-hero-bar {
  width: 44px;
  height: 3px;
  background: linear-gradient(90deg, #8b5cf6, #a855f7);
  border-radius: 999px;
  margin: 12px 0 16px;
  box-shadow: 0 2px 10px rgba(139, 92, 246, 0.5);
}

.kiu-hero-desc {
  font-size: 14.5px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 26px;
  max-width: 460px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

/* 3 Highlights Badges */
.kiu-highlights-row {
  display: flex;
  align-items: flex-start;
  gap: 32px;
}

.kiu-highlight-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kiu-highlight-icon-box {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(124, 58, 237, 0.32);
  border: 1px solid rgba(167, 139, 250, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 19px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
  transition: transform 0.25s ease, background 0.25s ease;
}

.kiu-highlight-item:hover .kiu-highlight-icon-box {
  transform: translateY(-3px);
  background: rgba(124, 58, 237, 0.5);
}

.kiu-highlight-text {
  display: flex;
  flex-direction: column;
}

.kiu-highlight-title {
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 2px;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

.kiu-highlight-sub {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.35;
  white-space: pre-line;
}

/* ==========================================================================
   Sign In Card Styles (With Night Mode & Day Mode themes)
   ========================================================================== */
.kiu-card-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  z-index: 10;
}

.kiu-login-card {
  width: 395px;
  border-radius: 24px;
  padding: 32px 32px 20px;
  position: relative;
  overflow: hidden;
  transition: background 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease, color 0.4s ease;
  animation: cardFadeUp 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes cardFadeUp {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* --- LIGHT / DAY MODE CARD --- */
.kiu-login-wrapper.day-mode .kiu-login-card {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 25px 65px -12px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.3);
  color: #1e293b;
}

.kiu-login-wrapper.day-mode .kiu-card-title {
  color: #0f172a;
}

.kiu-login-wrapper.day-mode .kiu-card-subtitle {
  color: #64748b;
}

.kiu-login-wrapper.day-mode .kiu-form-label {
  color: #334155;
}

.kiu-login-wrapper.day-mode .kiu-input-wrapper {
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
}

.kiu-login-wrapper.day-mode .kiu-input-wrapper:focus-within {
  background: #ffffff;
  border-color: #7c3aed;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12);
}

.kiu-login-wrapper.day-mode .kiu-input-icon {
  color: #94a3b8;
}

.kiu-login-wrapper.day-mode .kiu-input-field {
  color: #1e293b;
}

.kiu-login-wrapper.day-mode .kiu-input-field::placeholder {
  color: #94a3b8;
}

.kiu-login-wrapper.day-mode .kiu-input-toggle {
  color: #64748b;
}

.kiu-login-wrapper.day-mode .kiu-remember-box {
  color: #475569;
}

.kiu-login-wrapper.day-mode .kiu-forgot-link {
  color: #6366f1;
}

.kiu-login-wrapper.day-mode .kiu-card-watermark {
  border-top: 1px dashed #e2e8f0;
}

.kiu-login-wrapper.day-mode .kiu-watermark-img {
  filter: none;
  opacity: 0.38;
  mix-blend-mode: multiply;
}

.kiu-login-wrapper.day-mode .kiu-watermark-text {
  color: #64748b;
}


/* --- DARK / NIGHT MODE CARD --- */
.kiu-login-wrapper.night-mode .kiu-login-card {
  background: rgba(17, 24, 39, 0.78);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 25px 65px -12px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(255, 255, 255, 0.08);
  color: #f8fafc;
}

.kiu-login-wrapper.night-mode .kiu-card-title {
  color: #ffffff;
}

.kiu-login-wrapper.night-mode .kiu-card-subtitle {
  color: #94a3b8;
}

.kiu-login-wrapper.night-mode .kiu-form-label {
  color: #e2e8f0;
}

.kiu-login-wrapper.night-mode .kiu-input-wrapper {
  background: rgba(15, 23, 42, 0.65);
  border: 1.5px solid rgba(255, 255, 255, 0.15);
}

.kiu-login-wrapper.night-mode .kiu-input-wrapper:focus-within {
  background: rgba(15, 23, 42, 0.95);
  border-color: #a855f7;
  box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.25);
}

.kiu-login-wrapper.night-mode .kiu-input-icon {
  color: #94a3b8;
}

.kiu-login-wrapper.night-mode .kiu-input-field {
  color: #f8fafc;
}

.kiu-login-wrapper.night-mode .kiu-input-field::placeholder {
  color: #64748b;
}

.kiu-login-wrapper.night-mode .kiu-input-toggle {
  color: #94a3b8;
}

.kiu-login-wrapper.night-mode .kiu-input-toggle:hover {
  color: #c084fc;
}

.kiu-login-wrapper.night-mode .kiu-remember-box {
  color: #cbd5e1;
}

.kiu-login-wrapper.night-mode .kiu-forgot-link {
  color: #a78bfa;
}

.kiu-login-wrapper.night-mode .kiu-forgot-link:hover {
  color: #c084fc;
}

.kiu-login-wrapper.night-mode .kiu-card-watermark {
  border-top: 1px dashed rgba(255, 255, 255, 0.12);
}

.kiu-login-wrapper.night-mode .kiu-watermark-img {
  filter: invert(1) brightness(1.2);
  opacity: 0.35;
  mix-blend-mode: screen;
}

.kiu-login-wrapper.night-mode .kiu-watermark-text {
  color: #cbd5e1;
}


/* Common Card Typography & Elements */
.kiu-card-title {
  font-size: 26px;
  font-weight: 800;
  margin: 0 0 4px;
  letter-spacing: -0.5px;
}

.kiu-card-subtitle {
  font-size: 13px;
  margin-bottom: 20px;
}

.kiu-form-group {
  margin-bottom: 14px;
}

.kiu-form-label {
  display: block;
  font-size: 12.5px;
  font-weight: 600;
  margin-bottom: 5px;
}

.kiu-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 11px;
  padding: 0 13px;
  transition: all 0.2s ease;
}

.kiu-input-icon {
  font-size: 16px;
  margin-right: 9px;
  display: flex;
  align-items: center;
}

.kiu-input-field {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 10px 0;
  font-size: 13.5px;
  outline: none;
  font-weight: 500;
}

.kiu-input-toggle {
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  transition: color 0.15s ease;
}

/* Remember & Forgot Row */
.kiu-form-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 14px 0 20px;
}

.kiu-remember-box {
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  font-size: 12.5px;
  -webkit-user-select: none;
          user-select: none;
}

.kiu-remember-box input[type="checkbox"] {
  accent-color: #6366f1;
  width: 15px;
  height: 15px;
  border-radius: 4px;
  cursor: pointer;
}

.kiu-forgot-link {
  font-size: 12.5px;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.15s ease;
}

.kiu-forgot-link:hover {
  text-decoration: underline;
}

/* Submit Button */
.kiu-btn-submit {
  width: 100%;
  height: 45px;
  background: linear-gradient(135deg, #6366f1 0%, #7c3aed 100%);
  border: none;
  border-radius: 11px;
  color: #ffffff;
  font-size: 14.5px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 5px 15px -2px rgba(124, 58, 237, 0.45);
  transition: all 0.25s ease;
}

.kiu-btn-submit:hover:not(:disabled) {
  transform: translateY(-1.5px);
  box-shadow: 0 7px 20px -2px rgba(124, 58, 237, 0.6);
  filter: brightness(1.05);
}

.kiu-btn-submit:active:not(:disabled) {
  transform: translateY(0);
}

.kiu-btn-submit:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

/* Watermark Section */
.kiu-card-watermark {
  margin-top: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 14px;
}

.kiu-watermark-img {
  height: 40px;
  width: auto;
  object-fit: contain;
  margin-bottom: 5px;
  transition: opacity 0.25s ease, filter 0.25s ease;
}

.kiu-watermark-text {
  font-family: Georgia, "Times New Roman", Times, serif;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 2.5px;
  text-transform: uppercase;
}

/* Alerts */
.kiu-alert-error {
  background: #fef2f2;
  border: 1px solid #fee2e2;
  color: #ef4444;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12.5px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Footer */
.kiu-login-footer {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 48px 18px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
  flex-shrink: 0;
}

.kiu-footer-copy {
  margin: 0;
  font-weight: 400;
}

.kiu-footer-links {
  display: flex;
  align-items: center;
  gap: 14px;
}

.kiu-footer-links a {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  transition: color 0.2s ease;
}

.kiu-footer-links a:hover {
  color: #ffffff;
  text-decoration: underline;
}

.kiu-footer-separator {
  opacity: 0.4;
}

/* Responsive */
@media (max-width: 1024px) {
  .kiu-login-wrapper {
    min-height: 100vh;
    height: auto;
  }
  .kiu-login-main {
    flex-direction: column;
    padding: 24px;
    gap: 32px;
  }
  .kiu-hero-left {
    max-width: 100%;
    padding-right: 0;
    text-align: center;
  }
  .kiu-hero-bar {
    margin: 12px auto 16px;
  }
  .kiu-hero-desc {
    margin: 0 auto 24px;
  }
  .kiu-highlights-row {
    justify-content: center;
  }
  .kiu-login-card {
    width: 100%;
    max-width: 400px;
  }
  .kiu-login-header {
    padding: 18px 24px 0;
  }
  .kiu-login-footer {
    padding: 16px 24px;
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
}

@media (max-width: 640px) {
  .kiu-hero-title {
    font-size: 30px;
  }
  .kiu-highlights-row {
    flex-wrap: wrap;
    gap: 16px;
    justify-content: space-around;
  }
  .kiu-highlight-item {
    align-items: center;
    text-align: center;
  }
  .kiu-login-card {
    padding: 24px 20px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/feature-module/auth/login.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uGAAuG;EACvG,cAAc;EACd,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,sEAAsE;EACtE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE;2HACyH;AAC3H;;AAEA,qBAAqB;AACrB;EACE;2HACyH;AAC3H;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,yCAAyC;EACzC,yEAAyE;AAC3E;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,SAAO;AACT;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,oBAAoB;EACpB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,+FAA+F;EAC/F,wDAAwD;AAC1D;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,kCAAkC;AAClC;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,qFAAqF;EACrF,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;;AAGA,mCAAmC;AACnC;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,sFAAsF;EACtF,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;;AAGA,sCAAsC;AACtC;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,mDAAmD;EACnD,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,SAAS;IACT,6BAA6B;EAC/B;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ==========================================================================\n   KIU Resource Management System - Login Page Styles\n   ========================================================================== */\n\n.kiu-login-wrapper {\n  position: relative;\n  min-height: 100vh;\n  width: 100vw;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  color: #ffffff;\n  transition: all 0.5s ease;\n}\n\n/* Background Video & Overlays */\n.kiu-video-bg-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  overflow: hidden;\n  background-color: #0b0f19;\n}\n\n.kiu-video-bg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.8s;\n  pointer-events: none;\n}\n\n.kiu-video-bg.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.kiu-video-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  transition: background 0.6s ease;\n}\n\n/* Night Mode Overlay */\n.kiu-login-wrapper.night-mode .kiu-video-overlay {\n  background: radial-gradient(circle at 75% 50%, rgba(15, 23, 42, 0.25) 0%, rgba(10, 14, 26, 0.72) 100%),\n              linear-gradient(to right, rgba(10, 15, 30, 0.88) 0%, rgba(10, 15, 30, 0.45) 50%, rgba(10, 15, 30, 0.75) 100%);\n}\n\n/* Day Mode Overlay */\n.kiu-login-wrapper.day-mode .kiu-video-overlay {\n  background: radial-gradient(circle at 75% 50%, rgba(15, 23, 42, 0.08) 0%, rgba(15, 23, 42, 0.45) 100%),\n              linear-gradient(to right, rgba(15, 23, 42, 0.75) 0%, rgba(15, 23, 42, 0.22) 50%, rgba(15, 23, 42, 0.55) 100%);\n}\n\n/* Header */\n.kiu-login-header {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 22px 48px 0;\n  flex-shrink: 0;\n}\n\n.kiu-brand-container {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  text-decoration: none;\n}\n\n.kiu-crest-logo {\n  height: 58px;\n  width: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.3));\n}\n\n.kiu-brand-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.kiu-brand-title {\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 1;\n  color: #e51937;\n  letter-spacing: -0.5px;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, serif;\n}\n\n.kiu-brand-subtitle {\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-top: 3px;\n  opacity: 0.95;\n  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);\n}\n\n.kiu-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.kiu-theme-toggle {\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: #ffffff;\n  border-radius: 9999px;\n  padding: 7px 16px;\n  font-size: 12.5px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.kiu-theme-toggle:hover {\n  background: rgba(255, 255, 255, 0.26);\n  border-color: rgba(255, 255, 255, 0.45);\n  transform: translateY(-1px);\n}\n\n.kiu-secure-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  padding: 7px 16px;\n  border-radius: 9999px;\n  font-size: 12.5px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.kiu-secure-badge i {\n  color: #60a5fa;\n  font-size: 15px;\n}\n\n.kiu-version-divider {\n  opacity: 0.4;\n  margin: 0 3px;\n}\n\n/* Main Content Area */\n.kiu-login-main {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 56px;\n  width: 100%;\n  max-width: 1560px;\n  margin: auto;\n  flex: 1;\n}\n\n/* Hero Content (Left) */\n.kiu-hero-left {\n  max-width: 560px;\n  padding-right: 36px;\n}\n\n.kiu-hero-overline {\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  color: #a5b4fc;\n  margin-bottom: 8px;\n  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.kiu-hero-title {\n  font-size: 40px;\n  font-weight: 800;\n  line-height: 1.15;\n  color: #ffffff;\n  margin: 0 0 10px;\n  letter-spacing: -0.5px;\n  text-shadow: 0 3px 12px rgba(0, 0, 0, 0.45);\n}\n\n.kiu-hero-title .kiu-accent {\n  color: #9333ea;\n  background: linear-gradient(135deg, #a855f7 0%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.kiu-hero-bar {\n  width: 44px;\n  height: 3px;\n  background: linear-gradient(90deg, #8b5cf6, #a855f7);\n  border-radius: 999px;\n  margin: 12px 0 16px;\n  box-shadow: 0 2px 10px rgba(139, 92, 246, 0.5);\n}\n\n.kiu-hero-desc {\n  font-size: 14.5px;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.9);\n  margin-bottom: 26px;\n  max-width: 460px;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n}\n\n/* 3 Highlights Badges */\n.kiu-highlights-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 32px;\n}\n\n.kiu-highlight-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kiu-highlight-icon-box {\n  width: 42px;\n  height: 42px;\n  border-radius: 11px;\n  background: rgba(124, 58, 237, 0.32);\n  border: 1px solid rgba(167, 139, 250, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  font-size: 19px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);\n  transition: transform 0.25s ease, background 0.25s ease;\n}\n\n.kiu-highlight-item:hover .kiu-highlight-icon-box {\n  transform: translateY(-3px);\n  background: rgba(124, 58, 237, 0.5);\n}\n\n.kiu-highlight-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.kiu-highlight-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 2px;\n  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);\n}\n\n.kiu-highlight-sub {\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.78);\n  line-height: 1.35;\n  white-space: pre-line;\n}\n\n/* ==========================================================================\n   Sign In Card Styles (With Night Mode & Day Mode themes)\n   ========================================================================== */\n.kiu-card-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: relative;\n  z-index: 10;\n}\n\n.kiu-login-card {\n  width: 395px;\n  border-radius: 24px;\n  padding: 32px 32px 20px;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease, color 0.4s ease;\n  animation: cardFadeUp 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes cardFadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(18px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* --- LIGHT / DAY MODE CARD --- */\n.kiu-login-wrapper.day-mode .kiu-login-card {\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  box-shadow: 0 25px 65px -12px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.3);\n  color: #1e293b;\n}\n\n.kiu-login-wrapper.day-mode .kiu-card-title {\n  color: #0f172a;\n}\n\n.kiu-login-wrapper.day-mode .kiu-card-subtitle {\n  color: #64748b;\n}\n\n.kiu-login-wrapper.day-mode .kiu-form-label {\n  color: #334155;\n}\n\n.kiu-login-wrapper.day-mode .kiu-input-wrapper {\n  background: #f8fafc;\n  border: 1.5px solid #e2e8f0;\n}\n\n.kiu-login-wrapper.day-mode .kiu-input-wrapper:focus-within {\n  background: #ffffff;\n  border-color: #7c3aed;\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12);\n}\n\n.kiu-login-wrapper.day-mode .kiu-input-icon {\n  color: #94a3b8;\n}\n\n.kiu-login-wrapper.day-mode .kiu-input-field {\n  color: #1e293b;\n}\n\n.kiu-login-wrapper.day-mode .kiu-input-field::placeholder {\n  color: #94a3b8;\n}\n\n.kiu-login-wrapper.day-mode .kiu-input-toggle {\n  color: #64748b;\n}\n\n.kiu-login-wrapper.day-mode .kiu-remember-box {\n  color: #475569;\n}\n\n.kiu-login-wrapper.day-mode .kiu-forgot-link {\n  color: #6366f1;\n}\n\n.kiu-login-wrapper.day-mode .kiu-card-watermark {\n  border-top: 1px dashed #e2e8f0;\n}\n\n.kiu-login-wrapper.day-mode .kiu-watermark-img {\n  filter: none;\n  opacity: 0.38;\n  mix-blend-mode: multiply;\n}\n\n.kiu-login-wrapper.day-mode .kiu-watermark-text {\n  color: #64748b;\n}\n\n\n/* --- DARK / NIGHT MODE CARD --- */\n.kiu-login-wrapper.night-mode .kiu-login-card {\n  background: rgba(17, 24, 39, 0.78);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  box-shadow: 0 25px 65px -12px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n}\n\n.kiu-login-wrapper.night-mode .kiu-card-title {\n  color: #ffffff;\n}\n\n.kiu-login-wrapper.night-mode .kiu-card-subtitle {\n  color: #94a3b8;\n}\n\n.kiu-login-wrapper.night-mode .kiu-form-label {\n  color: #e2e8f0;\n}\n\n.kiu-login-wrapper.night-mode .kiu-input-wrapper {\n  background: rgba(15, 23, 42, 0.65);\n  border: 1.5px solid rgba(255, 255, 255, 0.15);\n}\n\n.kiu-login-wrapper.night-mode .kiu-input-wrapper:focus-within {\n  background: rgba(15, 23, 42, 0.95);\n  border-color: #a855f7;\n  box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.25);\n}\n\n.kiu-login-wrapper.night-mode .kiu-input-icon {\n  color: #94a3b8;\n}\n\n.kiu-login-wrapper.night-mode .kiu-input-field {\n  color: #f8fafc;\n}\n\n.kiu-login-wrapper.night-mode .kiu-input-field::placeholder {\n  color: #64748b;\n}\n\n.kiu-login-wrapper.night-mode .kiu-input-toggle {\n  color: #94a3b8;\n}\n\n.kiu-login-wrapper.night-mode .kiu-input-toggle:hover {\n  color: #c084fc;\n}\n\n.kiu-login-wrapper.night-mode .kiu-remember-box {\n  color: #cbd5e1;\n}\n\n.kiu-login-wrapper.night-mode .kiu-forgot-link {\n  color: #a78bfa;\n}\n\n.kiu-login-wrapper.night-mode .kiu-forgot-link:hover {\n  color: #c084fc;\n}\n\n.kiu-login-wrapper.night-mode .kiu-card-watermark {\n  border-top: 1px dashed rgba(255, 255, 255, 0.12);\n}\n\n.kiu-login-wrapper.night-mode .kiu-watermark-img {\n  filter: invert(1) brightness(1.2);\n  opacity: 0.35;\n  mix-blend-mode: screen;\n}\n\n.kiu-login-wrapper.night-mode .kiu-watermark-text {\n  color: #cbd5e1;\n}\n\n\n/* Common Card Typography & Elements */\n.kiu-card-title {\n  font-size: 26px;\n  font-weight: 800;\n  margin: 0 0 4px;\n  letter-spacing: -0.5px;\n}\n\n.kiu-card-subtitle {\n  font-size: 13px;\n  margin-bottom: 20px;\n}\n\n.kiu-form-group {\n  margin-bottom: 14px;\n}\n\n.kiu-form-label {\n  display: block;\n  font-size: 12.5px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.kiu-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  border-radius: 11px;\n  padding: 0 13px;\n  transition: all 0.2s ease;\n}\n\n.kiu-input-icon {\n  font-size: 16px;\n  margin-right: 9px;\n  display: flex;\n  align-items: center;\n}\n\n.kiu-input-field {\n  flex: 1;\n  border: none;\n  background: transparent;\n  padding: 10px 0;\n  font-size: 13.5px;\n  outline: none;\n  font-weight: 500;\n}\n\n.kiu-input-toggle {\n  font-size: 16px;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  transition: color 0.15s ease;\n}\n\n/* Remember & Forgot Row */\n.kiu-form-options {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 14px 0 20px;\n}\n\n.kiu-remember-box {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  cursor: pointer;\n  font-size: 12.5px;\n  user-select: none;\n}\n\n.kiu-remember-box input[type=\"checkbox\"] {\n  accent-color: #6366f1;\n  width: 15px;\n  height: 15px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.kiu-forgot-link {\n  font-size: 12.5px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.kiu-forgot-link:hover {\n  text-decoration: underline;\n}\n\n/* Submit Button */\n.kiu-btn-submit {\n  width: 100%;\n  height: 45px;\n  background: linear-gradient(135deg, #6366f1 0%, #7c3aed 100%);\n  border: none;\n  border-radius: 11px;\n  color: #ffffff;\n  font-size: 14.5px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  box-shadow: 0 5px 15px -2px rgba(124, 58, 237, 0.45);\n  transition: all 0.25s ease;\n}\n\n.kiu-btn-submit:hover:not(:disabled) {\n  transform: translateY(-1.5px);\n  box-shadow: 0 7px 20px -2px rgba(124, 58, 237, 0.6);\n  filter: brightness(1.05);\n}\n\n.kiu-btn-submit:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.kiu-btn-submit:disabled {\n  opacity: 0.75;\n  cursor: not-allowed;\n}\n\n/* Watermark Section */\n.kiu-card-watermark {\n  margin-top: 22px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-top: 14px;\n}\n\n.kiu-watermark-img {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n  margin-bottom: 5px;\n  transition: opacity 0.25s ease, filter 0.25s ease;\n}\n\n.kiu-watermark-text {\n  font-family: Georgia, \"Times New Roman\", Times, serif;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n  text-transform: uppercase;\n}\n\n/* Alerts */\n.kiu-alert-error {\n  background: #fef2f2;\n  border: 1px solid #fee2e2;\n  color: #ef4444;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 12.5px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Footer */\n.kiu-login-footer {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 48px 18px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.75);\n  flex-shrink: 0;\n}\n\n.kiu-footer-copy {\n  margin: 0;\n  font-weight: 400;\n}\n\n.kiu-footer-links {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.kiu-footer-links a {\n  color: rgba(255, 255, 255, 0.75);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.kiu-footer-links a:hover {\n  color: #ffffff;\n  text-decoration: underline;\n}\n\n.kiu-footer-separator {\n  opacity: 0.4;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .kiu-login-wrapper {\n    min-height: 100vh;\n    height: auto;\n  }\n  .kiu-login-main {\n    flex-direction: column;\n    padding: 24px;\n    gap: 32px;\n  }\n  .kiu-hero-left {\n    max-width: 100%;\n    padding-right: 0;\n    text-align: center;\n  }\n  .kiu-hero-bar {\n    margin: 12px auto 16px;\n  }\n  .kiu-hero-desc {\n    margin: 0 auto 24px;\n  }\n  .kiu-highlights-row {\n    justify-content: center;\n  }\n  .kiu-login-card {\n    width: 100%;\n    max-width: 400px;\n  }\n  .kiu-login-header {\n    padding: 18px 24px 0;\n  }\n  .kiu-login-footer {\n    padding: 16px 24px;\n    flex-direction: column;\n    gap: 10px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 640px) {\n  .kiu-hero-title {\n    font-size: 30px;\n  }\n  .kiu-highlights-row {\n    flex-wrap: wrap;\n    gap: 16px;\n    justify-content: space-around;\n  }\n  .kiu-highlight-item {\n    align-items: center;\n    text-align: center;\n  }\n  .kiu-login-card {\n    padding: 24px 20px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
